import React from 'react';
import VehicleItem from './VehiclesItem';
import CardWrapper from './CardWrapper';

const VehicleComponent = (props) => {

    /**
     * vehicles: creates a list of vehilces
     */
    const vehicles = props.data.map((element, index) => {
        const vehicleName = `${element.make}/${element.model}/${element.year}`;
        return (
            <div key={index}>
                <VehicleItem
                    {...element}
                    onVehicleClick={props.onVehicleClick}
                    name={vehicleName} />                
            </div>
        );
    });;

    //const vehicleCount = props.data.length;

    return (
        <CardWrapper>
            <div>
                <h3>
                    <i className="fa fa-car" aria-hidden="true" />
                    {' Vehicles '}
                    {/*
                        {'Found -'} {vehicleCount}
                     */}
                </h3>
                {vehicles}
            </div>
        </CardWrapper>
    );
}

export default VehicleComponent;


// WEBPACK FOOTER //
// ./src/Review/VehicleComponent.js